module.exports = __webpack_public_path__ + "img/15-1_06.06ea4f86.jpg";